module.exports = __webpack_public_path__ + "assets/img/strong-2.b0152fe8.png";